module.exports = __webpack_public_path__ + "assets/img/help_tj3.bb7d5875.png";